export default "__VITE_ASSET__DjndjYne__"